<app-pageheader [Parent]="this">
  <add-button AddRoute="/enforcement/citations/templates/new/edit"></add-button>
</app-pageheader>

<app-datalistview [Columns]="Columns" [ShowMap]="false" ApiUrl="enforcement/citations/templates/searches"
  [AllowEdit]="true" EditUrl="enforcement/citations/templates/:id">
  <app-filter-set>
    <div app-search-filter></div>
    <div app-search-button></div>
  </app-filter-set>
</app-datalistview> 